import {
  requests
} from '../../../api/agent'

export default {
  getAllThemesOgul: (params) => requests.getWithParams('/ReThemesOgul/getAll', params),
  getThemeOgulByName: (params) => requests.getWithParams('/ReThemesOgul/getByName', params),
  createThemeOgul: (params) => requests.post('/ReThemesOgul/CreateThemeOgul', params),
  deleteThemeOgul: (params) => requests.post('/ReThemesOgul/DeleteThemeOgul', params),
  updateThemeOgul: (params) => requests.post('/ReThemesOgul/UpdateThemeOgul', params),
  restoreThemeOgul: (params) => requests.post('/ReThemesOgul/RestoreThemeOgul', params)
}